<template>
	<div id="app">
		<TheToastContainer />
		<router-view />
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'App',

	watch: {
		$route() {
			// Reset toast, page title when change page
			this.setPageTitle({
				title: '',
				isShow: true,
			});
		},
	},

	methods: {
		...mapActions({
			setPageTitle: 'pageTitle/setPageTitle',
		}),
	},
};
</script>
